import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../Authentication/authService";
import ModuleNavbar from "../ModuleNavbar";
import { NavLink } from "react-router-dom";
import { CONFIG } from "../../config";

export const FailurePayment = () => {

  return (
    <>
      <ModuleNavbar />
      <main className="main-content">
        <div className="layout-container">
          <div className="layout-page">
            <section className="status-page-section">
              <div className="status-page-container">
                <div className="status-hero">
                  <div className="status-icon-wrapper failed-icon-wrapper">
                    <div className="status-icon-circle">
                      <i className="bx bx-x"></i>
                    </div>
                    <div className="status-icon-pulse"></div>
                  </div>

                  <h1 className="status-title failed-title">Payment Failed</h1>
                  <p className="status-subtitle">
                    We were unable to process your payment
                  </p>
                  <div className="btn btn-secondary">
                    <NavLink
                      to="/PaymentPlan"
                      style={{ color: "white", textDecoration: "none" }}
                    >
                      {" "}
                      Back
                    </NavLink>
                  </div>
                  {/* <div className="status-reference">
                    <span className="reference-label">Invoice Number</span>
                    <span className="reference-value">
                      {transactionDetails.EncryptedInvoiceNumber || "NA"}
                    </span>
                  </div> */}
                </div>

                {/* <div className="general-card status-summary-card">
                  <div className="status-summary-header">
                    <h3 className="summary-section-title">
                      Transaction Details
                    </h3>
                    <span className="summary-date">
                      <i className="bx bx-calendar"></i>
                      {getCurrentDate}
                    </span>
                  </div>

                  <div className="status-summary-body">
                    <div className="summary-row summary-row-highlight">
                      <span className="summary-label mb-0">
                        Attempted Amount
                      </span>
                      <span className="summary-value amount-failed">
                        {" "}
                        {`$ ${parseFloat(
                          transactionDetails.EncryptedSALEAMOUNT
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}` || "NA"}
                      </span>
                    </div>

                    <div className="summary-row">
                      <span className="summary-label mb-0">Reason</span>
                      <span className="summary-value">
                        {transactionDetails.EncyptedResult}
                      </span>
                    </div>
                  </div>
                </div> */}

                <div className="status-support">
                  <p className="support-text">Need help?</p>
                  <a href="tel:1-855-880-4791" className="support-link">
                    <i className="bx bx-phone"></i>
                    <div>
                      Call us at{" "}
                      <span className="d-block"> +1-855-880-4791 </span>
                    </div>
                  </a>
                </div>
              </div>
            </section>
          </div>
        </div>

        <button id="helpPopup-button" className="helpPopupButton">
          <i className="bx bx-help-circle"></i>
        </button>
      </main>
    </>
  );
};
